"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
exports.__esModule = true;
exports.RecordWebcam = void 0;
var react_1 = __importDefault(require("react"));
var Video_1 = require("./Video");
var Controls_1 = require("./Controls");
var mediaRecorder_1 = require("../mediaRecorder");
var utils_1 = require("../utils");
var constants_1 = require("../constants");
var RecordWebcam = /** @class */function (_super) {
  __extends(RecordWebcam, _super);
  function RecordWebcam(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      status: 'CLOSED'
    };
    _this.recorderOptions = __assign(__assign({}, constants_1.DEFAULT_OPTIONS), _this.props.options);
    _this.webcamRef = react_1["default"].createRef();
    _this.previewRef = react_1["default"].createRef();
    _this.options = __assign(__assign({}, _this.recorderOptions), _this.props.options);
    _this.download = _this.download.bind(_this);
    _this.getRecording = _this.getRecording.bind(_this);
    _this.openCamera = _this.openCamera.bind(_this);
    _this.handleError = _this.handleError.bind(_this);
    _this.close = _this.close.bind(_this);
    _this.retake = _this.retake.bind(_this);
    _this.start = _this.start.bind(_this);
    _this.stop = _this.stop.bind(_this);
    return _this;
  }
  RecordWebcam.prototype.componentDidUpdate = function (_, prevState) {
    if (this.state.status !== prevState.status) {
      if (this.props.getStatus) this.props.getStatus(this.state.status);
    }
  };
  RecordWebcam.prototype.handleError = function (error) {
    this.setState({
      status: 'ERROR'
    });
    console.error({
      error: error
    });
  };
  RecordWebcam.prototype.stopStream = function () {
    var _a;
    if (this.recorder.stream.id && ((_a = this.recorder) === null || _a === void 0 ? void 0 : _a.stopRecording)) {
      this.recorder.stream.stop();
    }
  };
  RecordWebcam.prototype.close = function () {
    if (this.previewRef.current) {
      this.previewRef.current.removeAttribute('src');
      this.previewRef.current.load();
    }
    this.setState({
      status: 'CLOSED'
    });
    this.stopStream();
  };
  RecordWebcam.prototype.openCamera = function () {
    return __awaiter(this, void 0, void 0, function () {
      var recorderInit, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3,, 4]);
            this.setState({
              status: 'INIT'
            });
            return [4 /*yield*/, mediaRecorder_1.mediaRecorder(this.options)];
          case 1:
            recorderInit = _a.sent();
            this.recorder = recorderInit;
            if (this.webcamRef.current) {
              this.webcamRef.current.srcObject = recorderInit.stream;
            }
            return [4 /*yield*/, new Promise(function (resolve) {
              return setTimeout(resolve, 1700);
            })];
          case 2:
            _a.sent();
            this.setState({
              status: 'OPEN'
            });
            return [3 /*break*/, 4];
          case 3:
            error_1 = _a.sent();
            this.handleError(error_1);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  RecordWebcam.prototype.start = function () {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
      var length_1, error_2;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _c.trys.push([0, 5,, 6]);
            if (!((_a = this.recorder) === null || _a === void 0 ? void 0 : _a.startRecording)) return [3 /*break*/, 4];
            return [4 /*yield*/, this.recorder.startRecording()];
          case 1:
            _c.sent();
            this.setState({
              status: 'RECORDING'
            });
            if (!((_b = this.props.options) === null || _b === void 0 ? void 0 : _b.recordingLength)) return [3 /*break*/, 4];
            length_1 = this.props.options.recordingLength * 1000;
            return [4 /*yield*/, new Promise(function (resolve) {
              return setTimeout(resolve, length_1);
            })];
          case 2:
            _c.sent();
            return [4 /*yield*/, this.stop()];
          case 3:
            _c.sent();
            this.stop();
            _c.label = 4;
          case 4:
            return [3 /*break*/, 6];
          case 5:
            error_2 = _c.sent();
            this.handleError(error_2);
            return [3 /*break*/, 6];
          case 6:
            return [2 /*return*/];
        }
      });
    });
  };
  RecordWebcam.prototype.stop = function () {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
      var blob, preview, error_3;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _c.trys.push([0, 4,, 5]);
            if (!(((_a = this.recorder) === null || _a === void 0 ? void 0 : _a.stopRecording) && ((_b = this.recorder) === null || _b === void 0 ? void 0 : _b.getBlob))) return [3 /*break*/, 3];
            return [4 /*yield*/, this.recorder.stopRecording()];
          case 1:
            _c.sent();
            return [4 /*yield*/, this.recorder.getBlob()];
          case 2:
            blob = _c.sent();
            preview = window.URL.createObjectURL(blob);
            if (this.previewRef.current) {
              this.previewRef.current.src = preview;
            }
            this.stopStream();
            this.setState({
              status: 'PREVIEW'
            });
            return [2 /*return*/];
          case 3:
            throw new Error('Stop recording error!');
          case 4:
            error_3 = _c.sent();
            this.handleError(error_3);
            return [3 /*break*/, 5];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  };
  RecordWebcam.prototype.retake = function () {
    return __awaiter(this, void 0, void 0, function () {
      var error_4;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4 /*yield*/, this.openCamera()];
          case 1:
            _a.sent();
            return [3 /*break*/, 3];
          case 2:
            error_4 = _a.sent();
            this.handleError(error_4);
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
  RecordWebcam.prototype.download = function () {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
      var blob, fileTypeFromMimeType, fileType, filename, error_5;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            _d.trys.push([0, 3,, 4]);
            if (!((_a = this.recorder) === null || _a === void 0 ? void 0 : _a.getBlob)) return [3 /*break*/, 2];
            return [4 /*yield*/, this.recorder.getBlob()];
          case 1:
            blob = _d.sent();
            fileTypeFromMimeType = ((_c = (_b = this.recorderOptions.mimeType) === null || _b === void 0 ? void 0 : _b.split('video/')[1]) === null || _c === void 0 ? void 0 : _c.split(';')[0]) || 'mp4';
            fileType = fileTypeFromMimeType === 'x-matroska' ? 'mkv' : fileTypeFromMimeType;
            filename = this.recorderOptions.fileName + "." + fileType;
            utils_1.saveFile(filename, blob);
            return [2 /*return*/];
          case 2:
            throw new Error('Error downloading file!');
          case 3:
            error_5 = _d.sent();
            this.handleError(error_5);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  RecordWebcam.prototype.getRecording = function () {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_b) {
        try {
          if ((_a = this.recorder) === null || _a === void 0 ? void 0 : _a.getBlob) {
            return [2 /*return*/, this.recorder.getBlob()];
          }
          return [2 /*return*/, Promise.resolve(null)];
        } catch (error) {
          this.handleError(error);
          console.error({
            error: error
          });
          return [2 /*return*/, Promise.reject(error)];
        }
        return [2 /*return*/];
      });
    });
  };
  RecordWebcam.prototype.render = function () {
    var _a, _b;
    return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement("style", null, "\n            ." + this.props.cssNamespace + "__wrapper {\n              display: -webkit-box;\n              display: -ms-flexbox;\n              display: flex;\n              -webkit-box-orient: vertical;\n              -webkit-box-direction: normal;\n              -ms-flex-flow: column nowrap;\n                      flex-flow: column nowrap;\n              -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                      justify-content: space-between;\n            }\n            ." + this.props.cssNamespace + "__status {\n              margin: 1rem 0;\n            }\n          "), react_1["default"].createElement("div", {
      className: this.props.cssNamespace + "__wrapper"
    }, (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.render) === null || _b === void 0 ? void 0 : _b.call(_a, {
      openCamera: this.openCamera,
      closeCamera: this.close,
      start: this.start,
      stop: this.stop,
      retake: this.retake,
      download: this.download,
      getRecording: this.getRecording,
      status: this.state.status
    }), !this.props.render && react_1["default"].createElement("div", {
      className: this.props.cssNamespace + "__status"
    }, "Status: " + this.state.status), !this.props.render && react_1["default"].createElement(Controls_1.Controls, {
      closeCamera: this.close,
      cssNamespace: this.props.cssNamespace,
      download: this.download,
      getRecording: this.getRecording,
      labels: this.props.controlLabels,
      openCamera: this.openCamera,
      retake: this.retake,
      start: this.start,
      status: this.state.status,
      stop: this.stop
    }), react_1["default"].createElement(Video_1.Video, {
      cssNamespace: this.props.cssNamespace,
      style: {
        display: "" + (this.state.status !== 'CLOSED' && (this.state.status === 'OPEN' || this.state.status === 'RECORDING') ? 'block' : 'none')
      },
      autoPlay: true,
      muted: true,
      loop: true,
      ref: this.webcamRef
    }), react_1["default"].createElement(Video_1.Video, {
      cssNamespace: this.props.cssNamespace,
      style: {
        display: "" + (this.state.status !== 'CLOSED' && this.state.status === 'PREVIEW' ? 'block' : 'none')
      },
      autoPlay: true,
      muted: true,
      loop: true,
      ref: this.previewRef
    })));
  };
  RecordWebcam.defaultProps = {
    cssNamespace: constants_1.NAMESPACES.CSS
  };
  return RecordWebcam;
}(react_1["default"].PureComponent);
exports.RecordWebcam = RecordWebcam;